import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwMdFormSaveActionResult } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, CourseEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../models/course-progress-variable-context.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { CourseRepositoryService } from "../services/course-repository.service";

@DwAction({
    keyName: 'course-copy',
    display: 'Course - Copy',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.Course,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Copy Course',
        iconClass: 'fa fa-copy',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Copies the selected course including the modules & lessons'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.contentAdmin,
        requireCanUpdate: true
    },
    defaultConfirmConfig :{
        showDialogConfig: true,
        showConfirmDialog: true,
        message: 'Are you sure?  This will copy the selected course including the modules & lessons!  <br><br><div class="dw-red">Note: This could take a few minutes if the course has a lot of modules and lessons.</div>',
        title: 'Copy Course'
    }
})
@Injectable()
export class CourseCopyActionService implements DwMdFormActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private courseRespositoryService: CourseRepositoryService,
        private dwEventService: DwEventService
    ) {
        
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwMdFormSaveActionResult> {
        const result: DwMdFormSaveActionResult = {
            success: false,
            validationFailed: false
        };

        const course = actionState.formApi.getFormData<CourseEntity>();

        if (!course.CourseId) {
            result.cancelled = true;
            return of(result);
        }

        return this.courseRespositoryService.copyCourse(course.CourseId)
            .pipe(map((newCourse) => {
                result.cancelled = false;
                result.success = !!newCourse;
                if (newCourse) {
                    setTimeout(() => {  
                        this.dwRoutingService.navigateToUrl(`/lms-admin/course-management/courses/edit/${newCourse.CourseId}`);
                    }, 2000);
                }

                result.message = result.success ? 'Course copied successfully...redirecting...' : 'Course copy failed.';

                return result;
            }));
    }
}